module.exports = __webpack_public_path__ + "media/images/icons/triangle-af2480dd06d02915779634712cb38fae.svg";